import React, { useCallback, useEffect, useState } from "react";
import { useApi } from "../../hooks/api";
import { useGlobal } from "../../hooks/global";
import { ITable } from "../../components/TableList";
import { IoAddCircleOutline } from "react-icons/io5";
import { PageList } from "../../components/PageList";
import { IPermissionsTypes } from "../../utils/permissions";
import { setUpConsultation } from "../../services/generalServices";
import { ModalLoading } from "../../components/Loadings/ModalLoading";
import { IActions, IFilters, INotificationRulesProps } from "../../interfaces/index";
import { ModalNotificationRule } from "../../components/Modals/ModalNotificationRule";
import { activity_mapper } from "../NotificationsHistory";
import { getBadgeColumn, getBadgeOutlineColumn, getBadgeOutlineColumnTimeMode, getBadgeTypeColumn } from "../../utils/columnsTables";
import { secondary } from "../../theme";
import { FaEdit, FaRegCalendarAlt, FaWhatsapp } from "react-icons/fa";
import { MdDelete, MdHotel, MdOutlineEmail } from "react-icons/md";
import { CgCalendarNext, CgTime } from "react-icons/cg";
import { BsFillHousesFill } from "react-icons/bs";

const initialFilters: IFilters[] = [];

const initialTable: ITable = {
  data: [],
  columns: [
    {
      attr: "name",
      name: "Nome",
      style: { width: '100%' },
      styleContent: { fontSize: 14, fontWeight: 600 },
    },
    {
      attr: "time_mode",
      name: "Modo de Tempo",
      style: { justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
      styleContent: { fontSize: 14, fontWeight: 600, justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
    },
    {
      attr: "activity",
      name: "Atividade",
      style: { justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
      styleContent: { fontSize: 14, fontWeight: 600, justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
    },
    {
      attr: "accommodation",
      name: "Acomodação",
      style: { justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
      styleContent: { fontSize: 14, fontWeight: 600, justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
    },
    {
      attr: "group",
      name: "Grupo",
      style: { justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
      styleContent: { fontSize: 14, fontWeight: 600, justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
    },
/*     {
      attr: "model",
      name: "Modelo",
      style: { justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
      styleContent: { fontSize: 14, fontWeight: 600, justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
    }, */
    {
      attr: "send_type",
      name: "Tipo de Envio",
      style: { justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
      styleContent: { fontSize: 14, fontWeight: 600, justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
    },
    {
      attr: "recipient_type",
      name: "Destinatário",
      style: { justifyContent: 'center', textAlign: 'center', alignItems: 'center' },
      styleContent: { fontSize: 14, fontWeight: 600 },
    }
  ],
};

const TIME_MODE_MAPPER: { [key: string]: string } = {
  '10 before': '10 dias antes',
  '9 before': '9 dias antes',
  '8 before': '8 dias antes',
  '7 before': '7 dias antes',
  '6 before': '6 dias antes',
  '5 before': '5 dias antes',
  '4 before': '4 dias antes',
  '3 before': '3 dias antes',
  '2 before': '2 dias antes',
  '1 before': '1 dia antes',
  'on day': 'No dia',
  '1 after': '1 dia depois',
  '2 after': '2 dias depois',
  '3 after': '3 dias depois',
  '4 after': '4 dias depois',
  '5 after': '5 dias depois',
  '6 after': '6 dias depois',
  '7 after': '7 dias depois',
  '8 after': '8 dias depois',
  '9 after': '9 dias depois',
  '10 after': '10 dias depois',
}

const RECIPIENT_TYPE_MAPPER: { [key: string]: string } = {
  'guest': 'Contato do hóspede',
  'other': 'Outro contato',
}

export const NotificationRulesList: React.FC = () => {
  const { user, api } = useApi();
  const { theme, paginationLimit, notify } = useGlobal();

  const [atualPage, setAtualPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [openModal, setOpenModal] = useState(false);
  const [numOfNotificationRules, setNumOfNotificationRules] = useState(0);
  const [updatedAt, setUpdatedAt] = useState(new Date());
  const [loadingNotificationRules, setLoadingNotificationRules] = useState(true);
  const [searchString, setSearchString] = useState<string>("");
  const [numberOfPages, setNumberOfPages] = useState<number>(1);
  const [notificationRuleSelected, setNotificationRuleSelected] = useState<INotificationRulesProps | null>(null);
  const [table, setTable] = useState<ITable>(initialTable);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const selectNotificationRule = useCallback((userType: INotificationRulesProps) => {
    setNotificationRuleSelected({ ...userType });
    setOpenModal(true);
  }, []);

  const searchNotificationRules = useCallback(
    async (page, _filters = null) => {
      setAtualPage(page);
      setLoadingNotificationRules(true);
      try {
        const filters_obj = _filters
          ? _filters
          : { ...filters, search: searchString };

        let string = setUpConsultation(filters_obj);
        let url = `/notification-rules?page=${page}&limit=${paginationLimit}&${string}`;

        const result = await api.get(url);
        const new_users_types = result.data.data as INotificationRulesProps[];
        setTable((atual) => {
          const new_table = { ...atual };
          new_table.data = [];
          new_users_types.forEach((rule) => {
            new_table.data.push({
              id: rule.id,
              name: rule.name,
              activity: getBadgeOutlineColumn({ name: activity_mapper[rule.activity], theme, color: secondary[theme], icon: <CgCalendarNext size={16} style={{ marginTop: 0.72, marginRight: 3 }} /> }),
              accommodation: getBadgeColumn({ ...(rule?.accommodation ?? {}), theme, icon: <MdHotel size={16} style={{ marginTop: 0.72, marginRight: 3 }} />, notFoundText: 'Todas as acomodações' }),
              group: getBadgeColumn({ ...(rule?.group ?? {}), theme, icon: <BsFillHousesFill size={16} style={{ marginTop: 0.72, marginRight: 3 }} />, notFoundText: 'Todos os Grupos' }),
              model: rule?.model?.name,
              recipient_type: RECIPIENT_TYPE_MAPPER[rule.recipient_type],
              send_type: getBadgeTypeColumn({ type: rule.send_type === 'email' ? 'E-mail' : 'WhatsApp', theme, icon: rule.send_type === 'wpp' ? <FaWhatsapp size={16} style={{ marginTop: 0.72, marginRight: 3 }} /> : <MdOutlineEmail size={16} style={{ marginTop: 0.72, marginRight: 3 }} /> }),
              time_mode: getBadgeOutlineColumnTimeMode({ name: TIME_MODE_MAPPER[rule.time_mode], theme, color: secondary[theme], icon: <FaRegCalendarAlt size={13} style={{ marginTop:1.7, marginRight: 3 }}/>, time_send_notification: rule?.time_send_notification}),
              this: rule,
            });
          });
          return { ...new_table };
        });

        setNumOfNotificationRules(result.data.count);
        setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
        setUpdatedAt(new Date());
      } catch (err) {
        notify("Erro na busca pelas regras de notificação!", "error");
      }
      setLoadingNotificationRules(false);
    },
    [user, filters, searchString]
  );

  const changeStatus = useCallback(
    async (id: string, old_status: boolean) => {
      const status_active = !old_status;

      setTable((atual) => {
        const new_table = { ...atual };
        const pos = new_table.data.findIndex((d) => d?.this.id === id);
        if (pos !== -1) new_table.data[pos].this.status = status_active;
        return { ...new_table };
      });

      try {
        await api.put(`/notification-rules/${id}`, { status: status_active });
        notify("Status da regra de notificação atualizado com sucesso", "success");
      } catch (err) {
        notify("Erro ao alterar status da empresa", "error");
        setTable((atual) => {
          const new_table = { ...atual };
          const pos = new_table.data.findIndex((d) => d?.this.id === id);
          if (pos !== -1) new_table.data[pos].this.status = old_status;
          return { ...new_table };
        });
      }
    },
    []
  );


  const openModalNewUserType = useCallback(() => {
    setNotificationRuleSelected(null);
    setOpenModal(true);
  }, []);

  const handleAction = (action_id: string) => {
    if (action_id === "new_item") openModalNewUserType();
  };

  const actionsInitial: IActions[] = [
    {
      main_option: { text: "Nova regra de notificação", id: "new_item" },
      className: "new_item",
      icon: <IoAddCircleOutline size={20} className="new_item" />,
      options: [],
      type: "solid",
      permissions: ["NOTIFICATIONS"],
    },
  ];

  const handleConfirm = useCallback(async (id: string) => {
    setLoadingDelete(true);
    try {
      await api.delete(`/notification-rules/${id}`);
      notify("Regra de notificação excluída com sucesso!", "success");
      await searchNotificationRules(1);
    } catch (error: any) {
      const default_message = "Erro ao excluir a regra de notificação!";
      const message = error.response?.data?.detail ?? default_message;
      notify(message, message === default_message ? "error" : "alert");
    }
    setLoadingDelete(false);
  }, [searchNotificationRules]);

  const alertDelete = useCallback(async (type: INotificationRulesProps): Promise<void> => {
    const result = window.confirm("Tem certeza que deseja excluir a regra de notificação " + type.name);

    if (result) handleConfirm(type.id as unknown as string);
  }, [handleConfirm]);

  const onSaveUserType = useCallback(() => {
    setOpenModal(false);
    searchNotificationRules(1);
  }, [user, filters, searchString]);

  const listActions = [
    {
      title: "Editar",
      onClick: (userType: INotificationRulesProps) => selectNotificationRule(userType),
      icon: <FaEdit color={secondary[theme]} size={20} />,
      disabled: () =>
        !user.user_type.permissions.includes(
          "NOTIFICATIONS" as IPermissionsTypes
        ),
    },
    {
      title: "Excluir",
      onClick: (userType: INotificationRulesProps) => alertDelete(userType),
      icon: <MdDelete color={secondary[theme]} size={20} />,
      disabled: () =>
        !user.user_type.permissions.includes(
          "NOTIFICATIONS" as IPermissionsTypes
        ),
    },
  ];


  useEffect(() => {
    searchNotificationRules(1);
  }, []);

  return (
    <PageList
      updatedAt={updatedAt}
      loading={loadingNotificationRules}
      setLoading={setLoadingNotificationRules}
      numberOfItems={numOfNotificationRules}
      actions={actionsInitial}
      onClickOption={handleAction}
      textHeader="Regras de Notificação"
      textItems="regras de notificação encontradas"
      text_loading="Buscando Regras de Notificação"
      text_empty={"Nenhuma regra de notificação encontrada"}
      theme={theme}
      initialFilters={initialFilters}
      onChangeFilters={setFilters}
      table={table}
      listActions={listActions}
      pages={numberOfPages}
      page={atualPage}
      search={searchNotificationRules}
      have_status={true}
      onChangeSearch={setSearchString}
      status_action={changeStatus}
    >
      {openModal && (
        <ModalNotificationRule
          onCancel={() => setOpenModal(false)}
          onSave={onSaveUserType}
          openModal={openModal}
          backgroundVisible={false}
          defaultId={notificationRuleSelected?.id}
        />
      )}
      {loadingDelete && <ModalLoading loading={loadingDelete} theme={theme} />}
    </PageList>
  );
};
